<template>
  <div
    data-test="skeleton-card"
    aria-hidden="true"
    class="flex flex-col gap-2 rounded-lg border p-3"
  >
    <BaseSkeletonBar height="h-5" width="w-3/4" class="dark:bg-slate-600" />
    <BaseSkeletonBar height="h-3" width="w-1/2" class="dark:bg-slate-600" />
    <BaseSkeletonBar height="h-3" width="w-2/3" class="dark:bg-slate-600" />
    <div class="flex flex-row items-center justify-between gap-2">
      <BaseSkeletonBar height="h-6" width="w-24" class="dark:bg-slate-600" />
      <BaseSkeletonBar
        height="h-6"
        width="w-6"
        class="rounded-full dark:bg-slate-600"
      />
    </div>
  </div>
</template>

<script>
import BaseSkeletonBar from '@c/BaseSkeletonBar.vue'

/** Placeholder shaped like a normal-size TaskDossierCard: title, two text lines, status pill and avatar. */
export default {
  name: 'TaskCardSkeleton',
  components: { BaseSkeletonBar }
}
</script>
